import type { Step } from '@lemonade-hq/chat-engine';
import type { WizardExtendedStepWithPersistence } from '@lemonade-hq/chat-wizard-client-base';
import type { I18nContextValue } from '@lemonade-hq/nuiza';
import type { UniclientStepPresentation } from '@lemonade-hq/uniclient-chat';
import { redirect } from '@lemonade-hq/uniclient-chat';

interface ErrorPageParams {
  readonly urls: {
    readonly home: string;
    readonly logout: string;
  };
  readonly s: I18nContextValue['s'];
}

export function errorStep403({
  s,
  urls,
}: ErrorPageParams): WizardExtendedStepWithPersistence<Step<UniclientStepPresentation, unknown>> {
  return {
    name: 'error-forbidden',
    presentation: {
      frame: {
        title: s('chat.error.403.title'),
        action: redirect({ content: s('chat.error.403.action'), url: urls.logout }),
        secondaryAction: redirect({ content: s('chat.error.403.secondary_action'), url: urls.home }),
      },
    },
  };
}
